<template>
    <div class="wrapper-releted" v-if="campaign.related.length > 0">
        <div class="title-releted">{{ lbl.detail.also_like }}</div>
        <carousel id="RelatedSlider"
                  :responsive="configCarousel.responsive"
                  :margin="16"
                  :lazyLoad="true"
                  :nav="false"
                  :dots="false">
            <RelatedItem v-for="(v,k) in campaign.related" :key="k"
                        :lbl="lbl"
                        :campaign="v"
            ></RelatedItem>
        </carousel>
    </div>
</template>

<script>
import Carousel from 'vue-owl-carousel';
import RelatedItem from './RelatedItem.vue';
export default {
    name: 'RelatedSlider',
    components: {
        Carousel,
        RelatedItem
    },
    props: {
        lbl: Object,
        campaign: Object,
    },
    data: function() {
        return {
            configCarousel: {
                responsive: {
                    0: {
                        items: 6,
                        stagePadding: 16
                    },
                },
            },
        }
    },
    created: function () {
    },
    methods: {
    }
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";
    #RelatedSlider {
        .owl-carousel {
            .owl-stage-outer {
                .owl-stage {
                    padding-left: 0 !important;
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .wrapper-releted {
        .title-releted{
            padding: 0 0 15px;
        }
    }
</style>
